<template>
  <div class="v-paginator">
    <nav class="border pt-3" aria-label="navigation">
      <paginate
        :page-count="this.data.total_pages"
        :click-handler="pageCallback"
        :prev-text="'Назад'"
        :next-text="'Вперед'"
        :container-class="'pagination justify-content-center'"
        :page-class="'page-item'"
        :page-link-class="'page-link'"
        :prev-class="'page-item'"
        :prev-link-class="'page-link'"
        :next-class="'page-item'"
        :next-link-class="'page-link'">
      </paginate>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'v-paginator',
  props: ['data'],
  methods: {
    pageCallback(pageNum) {
      this.$emit('change', pageNum);
    },
  },
};
</script>
